import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { Configuration, GlobalAuthorizeApi, OrganizationAuthorizeApi, UserAccessRequest, UserAccessSubmitOtpRequest } from "../api/client-axios";
import { REACT_APP_SIMULATE_SEND_SMS } from "../config";
import { ApiError } from "../model/apiError";
import { ConfirmMode } from "../model/confirmEnum";
import { Problem } from "../model/problem";
import { apiConfiguration } from "./server";
import { applyRejection } from "./thunkError";



export interface OtpState{
    confirmMode? : ConfirmMode,
    phoneNumber?: string,
    otpCode?: string,
    status?: "idle" | "loading" | "error" | "success" | "auth-error";
    error?: string | Problem;
    code?: number;
}


export const initialOtpState : OtpState = {
    status: "idle",
    confirmMode: ConfirmMode.None,
}

export const requiestOtpCode =  createAsyncThunk<void, UserAccessRequest, { rejectValue: ApiError }>('otp/requestOtpCode', async (userAccessRequest, thunkApi) => {
    try {
        const api = new OrganizationAuthorizeApi(apiConfiguration());
        const response = await api.apiV1OrganizationsMyAdministrationRequestAccessPost(REACT_APP_SIMULATE_SEND_SMS, userAccessRequest)
        return response.data;
    } catch (error: AxiosError | any) {
        return thunkApi.rejectWithValue({ message: error?.response?.data, statusCode: error?.response?.status });
    }
});

export const confirmOtp =  createAsyncThunk<void, { organizationId: string, userOtpRequest: UserAccessSubmitOtpRequest}, { rejectValue: ApiError }>('otp/confirmOtpCode', async (args, thunkApi) => {
    try {
        const api = new GlobalAuthorizeApi(apiConfiguration());
        const response = await api.apiV1AdministrationAuthorizationConfirmNewAccountPost(args.organizationId, args.userOtpRequest)
        return response.data;
    } catch (error: AxiosError | any) {
        return thunkApi.rejectWithValue({ message: error?.response?.data, statusCode: error?.response?.status });
    }
});

  export const initOtpState = createAction('otp/initState');

  export const clearSendOtpError = createAction('otp/clearError');


const otpSlice = createSlice({
    name: 'otp',
    initialState: initialOtpState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(requiestOtpCode.pending, (state, _) => {

                state.status = "loading";
            })
            .addCase(requiestOtpCode.fulfilled, (state, action) => {
                state.status = "success";
                state.phoneNumber =  action.meta.arg.phoneNumber!
                state.confirmMode = ConfirmMode.Send;
            })
            .addCase(requiestOtpCode.rejected, (state, action) => {
                state.phoneNumber =  action.meta.arg.phoneNumber!
                applyRejection(state, action);
            })
            .addCase(confirmOtp.pending, (state, _) => {
                state.status = "loading";
            })
            .addCase(confirmOtp.fulfilled, (state, action) => {
                state.otpCode = action.meta.arg.userOtpRequest.code!;
                state.phoneNumber =  action.meta.arg.userOtpRequest.phoneNumber!
                state.confirmMode = ConfirmMode.Confirm;
                state.status = "success";
            })
            .addCase(confirmOtp.rejected, (state, action) => {
                state.otpCode = action.meta.arg.userOtpRequest.code!;
                applyRejection(state, action);
            })
            .addCase(initOtpState,(state,_)=>{
              state.status = "idle";
              state.code = undefined;
              state.phoneNumber = undefined;
              state.confirmMode = ConfirmMode.None;
              state.otpCode = undefined;
              state.error = undefined;
                
            })
            .addCase(clearSendOtpError, (state, action) => {
                state.status = "idle";
            })
            .addDefaultCase((state,action)=>{})
          

    }
});

export default otpSlice.reducer;
